window.addEventListener("DOMContentLoaded", () => {

  // 決済処理を許可するurlは</items/:id/transactions>の場合です。
  const path = location.pathname
  const params = path.replace(/items/g, '').replace(/orders/g, '').replace(/\//g, '');

  if (path.includes("items") && path.includes("orders") && /^([1-9]\d*|0)$/.test(params)) {
    const PAYJP_PK = process.env.PAYJP_PK
    // Payjp.setPublicKey(PAYJP_PK);
    const payjp = Payjp(PAYJP_PK);
    const elements = payjp.elements();
  
    const numberElement = elements.create('cardNumber');
    const expiryElement = elements.create('cardExpiry');
    const cvcElement = elements.create('cardCvc');

    numberElement.mount('#number-form');
    expiryElement.mount('#expiry-form');
    cvcElement.mount('#cvc-form');

    const submit = document.getElementById("button");

    submit.addEventListener("click", (e) => {
      e.preventDefault();
      payjp.createToken(numberElement).then(function (response) {
        if (response.error) {
        } else {
          const token = response.id;
          const renderDom = document.getElementById("charge-form");
          const tokenObj = `<input value=${token} type="hidden" name='pay_form[token]'>`;
          renderDom.insertAdjacentHTML("beforeend", tokenObj);
          console.log(token);
        }
        document.getElementById("charge-form").submit();
      });
    })
  }
});